// Copyright (c) 2025 Nebularis Holdings LLC
// Licensed to Nutrx Solutions under a non-exclusive, non-transferable license.
// See IP License Agreement for usage restrictions.

// frontend/src/components/execution-plans/OperationalPlaybook.jsx

import React from "react";
import { ExecutionPlanSection, EmptyPanel, bodyTextStyle, displayValue } from "./ExecutionSummaryCard";

export default function OperationalPlaybook({ playbook }) {
  const sections = Array.isArray(playbook?.sections) ? playbook.sections : [];

  if (!sections.length) {
    return <EmptyPanel title="No operational playbook" message="The generated task plan did not include playbook sections yet." />;
  }

  return (
    <ExecutionPlanSection eyebrow="Playbook" title={playbook?.title || "Operational playbook"} badge={playbook?.connector || "task scoped"}>
      <div style={{ display: "grid", gap: 12 }}>
        {sections.map((section, index) => {
          const steps = Array.isArray(section?.steps) ? section.steps : [];
          return (
            <div key={`${section?.name || "section"}-${index}`} style={{ border: "1px solid rgba(148, 163, 184, 0.16)", borderRadius: 14, padding: 12, background: "rgba(2, 6, 23, 0.24)" }}>
              <strong style={{ color: "#f8fafc", display: "block", marginBottom: 8 }}>{displayValue(section?.name)}</strong>
              {steps.length ? (
                <ol style={{ color: "#bfdbfe", fontSize: 13, lineHeight: 1.55, margin: 0, paddingLeft: 18 }}>
                  {steps.map((step, stepIndex) => (
                    <li key={`${section?.name || "section"}-${stepIndex}`}>
                      <strong style={{ color: "#dbeafe" }}>{displayValue(step?.title)}</strong>
                      {step?.detail ? <span> — {displayValue(step.detail)}</span> : null}
                    </li>
                  ))}
                </ol>
              ) : (
                <p style={bodyTextStyle}>No steps returned for this section.</p>
              )}
            </div>
          );
        })}
      </div>
    </ExecutionPlanSection>
  );
}
